var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 46 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(46 46.7734) rotate(-180)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9195",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "46",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "46",
              y: "46.7734",
              width: "46",
              height: "46",
              rx: "6",
              transform: "rotate(-180 46 46.7734)",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9195)" } }, [
        _c("path", {
          attrs: { d: "M46 0.773438H0V46.7734H46V0.773438Z", fill: "white" },
        }),
        _c("path", {
          attrs: {
            d: "M46 0.773438H0V23.7736C0 36.476 10.2976 46.7734 23.0002 46.7734C35.7026 46.7734 46 36.476 46 23.7736V0.773438Z",
            fill: "#FFB400",
          },
        }),
        _c("path", {
          attrs: {
            d: "M22.9991 14.6641C17.9687 14.6641 13.8906 18.7421 13.8906 23.7726C13.8906 28.8028 17.9687 32.8808 22.9991 32.8808C28.0293 32.8808 32.1073 28.8028 32.1073 23.7726C32.1073 18.7421 28.0293 14.6641 22.9991 14.6641Z",
            fill: "#3C6EC8",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.0515 0.357926L-0.224609 0.527344L-0.0536985 47.2112L46.2224 47.0418L46.0515 0.357926Z",
            fill: "#F15073",
          },
        }),
        _c("path", {
          attrs: {
            d: "M-0.680008 0.94938C12.349 0.901685 22.9503 11.4248 22.998 24.4553C23.0457 37.4846 12.5217 48.0851 -0.507269 48.1328C-13.5366 48.1805 -24.1377 37.6573 -24.1854 24.628C-24.2331 11.5976 -13.7094 0.997088 -0.680008 0.94938Z",
            fill: "#F780A0",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.5077 0.773599C59.5367 0.725891 70.1378 11.249 70.1855 24.2795C70.2332 37.3088 59.7094 47.9093 46.6805 47.957C33.6508 48.0047 23.0498 37.4815 23.0021 24.4522C22.9544 11.4218 33.4781 0.821294 46.5077 0.773599Z",
            fill: "#D4436A",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }